import React from 'react';
import ReactDOM from 'react-dom';
import Editor from '../Editor';
import Api from '../Api/Api.js';
import { SocketService } from "../Api/SocketService.js";
import axios from 'axios';
import { aesUtils } from "../Utils/AesUtil.js";
import orderUtil from '../Utils/orderUtil.js';
import { patternSocket } from "../Utils/lvsSocket.js";
axios.defaults.headers.post['Content-Type'] = 'application/json';

//开发模式
if(process.env.NODE_ENV === "development"){

}
class PatternEditor {

  constructor(){
    this.lvsPatternEditorId = "lvs_pattern_editor" + (new Date().getTime());
    this.domId = "";
    this.socketService = null;
  };

  //初始化Pattern编辑器
  /*
  uid: 平台使用k，v值通过AES加密生成
  pf: 平台名称
  videoId: 平台需要创建pattern的视频id
  domId:       Pattern编辑器将会挂载到此元素上
  editorWidth：Pattern编辑器的宽度
  useRole:   用户角色：1创作者，2普通用户
  videoEl:      video标签元素
  videoTime：   视频时长(毫秒)
  playProgress：视频播放进度(毫秒)
  speed:        视频播放速度
  */
  playPattern(){
    let id = "lvsPatternEditorId_event_610";
    let playEventSpan = document.getElementById(id);
    if(!playEventSpan){
      playEventSpan = document.createElement( "span");
      playEventSpan.id = id;
      document.body.appendChild(playEventSpan);
    }
    setTimeout(()=>{
      playEventSpan.click();
    }, 100)
  };
  createPatternEditor(name, pf, videoId, videoEl, domId, editorWidth, role, speed, showCustomerQrcode){
    //加密uid，到时候正式给网站开发者使用，是他们自己加密，这里就不需要再加密了 todo
    const uid = aesUtils.aesEncrypt(name);
    const checkRes = this.checkParams(videoEl, domId, editorWidth);
    if(checkRes){
      let videoTime = videoEl.duration*1000;
      let playProgress = 0;
      this.domId = domId;
      let isMobile = orderUtil.isMobile();
      let editorInfo = {
        uid,
        pf,
        videoId,
        videoEl,
        editorWidth,
        videoTime,
        playProgress,
        isMobile,
        role,
        speed: parseFloat(speed).toFixed(1),
        lvsPatternEditorId: this.lvsPatternEditorId,
        showCustomerQrcode: showCustomerQrcode
      };
      let _this = this;
      let hasRepeatSocket = false;
      let repeatSocket = null;
      if(patternSocket &&  patternSocket.socketInstanceList && patternSocket.socketInstanceList.length>0){
        for(let i=0; i<patternSocket.socketInstanceList.length; i++){
          let item = patternSocket.socketInstanceList[i];
          if(item.videoId === videoId){
            hasRepeatSocket = true;
            repeatSocket = item.socketService;
            break;
          }
        }
      }
      if(hasRepeatSocket){
        //已存在相同通道的socket，无需新建socket通道
        ReactDOM.render(
          <React.StrictMode>
            <Editor 
              editorInfo={editorInfo} 
              socketServiceInstanct={repeatSocket}
            />
          </React.StrictMode>,
          document.getElementById(domId)
        );
        //查询当前用户的跟随状态
        setTimeout(()=>{
          if(repeatSocket){
            repeatSocket.getSyncStatus();
            repeatSocket.socketEmitMsg('ModifyVideoPatternDTO', {});
          }
        }, 300);
        
      }else{
        var formData = new FormData();
        formData.append('uid', uid);
        formData.append('pf', pf);
        formData.append('videoId', videoId);
        axios.post(Api.getToken, formData).then(function (res) {
          let data = res.data;
          if(data && data.code === 0){
            let socketIoPath = data.data.socketIoPath;
            let wsServerUrl = data.data.wsServerUrl;
            let url = Api.getPattern + "?videoId=" + videoId + "&pf=" + pf;
            axios.get(url).then((res)=>{
              //以下两种情形才需提前生成socket
              //1、当前视频有pattern
              //2、当前用户角色是创作者
              let tmpSocketService = null;
              if(res.data.code === 0 || role === 1){
                tmpSocketService = new SocketService();
                _this.socketService = tmpSocketService;
                tmpSocketService.initSocket(wsServerUrl,socketIoPath);
                patternSocket.socketInstanceList.push({"videoId": videoId, "socketService": tmpSocketService});
              }
              let tmpId = "lvs_pattern_editor" + (new Date().getTime());
              editorInfo = {...editorInfo,lvsPatternEditorId:tmpId };
              ReactDOM.render(
                <React.StrictMode>
                  <Editor
                    editorInfo={editorInfo}
                    socketServiceInstanct={tmpSocketService}
                  />
                </React.StrictMode>,
                document.getElementById(domId)
              );
              //查询当前用户的跟随状态
              setTimeout(()=>{
                if(tmpSocketService){
                  tmpSocketService.getSyncStatus();
                  tmpSocketService.socketEmitMsg('ModifyVideoPatternDTO', {});
                }
              }, 300);
              _this.playPattern()
            });
          }else{
            console.error("getToken error--", res);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      }      
    }
  };
  async queryPattern(videoId, pf){
    let url = Api.getPattern + "?videoId=" + videoId + "&pf=" + pf;
    let res = await axios.get(url);
    if(res.data && res.data.code === 0){
      return res.data.data;
    }
    return null;
  };
  //初始化入口，创建pattern
  init(uid, pf, videoId, videoEl, domId, editorWidth, role, speed){
    if (domId&&document.getElementById(domId).getElementsByTagName('div').length) {//如果不是第一次进入，就重新给lvsPatternEditorId赋值
      let childrenid  =  document.getElementById(domId).getElementsByTagName('div')[0].id
      this.lvsPatternEditorId = childrenid
    }
    if(!(patternSocket && patternSocket.socketInstanceList.length > 0)){
      this.lvsPatternEditorId = "lvs_pattern_editor" + (new Date().getTime());
    }
    this.createPatternEditor(uid, pf, videoId, videoEl, domId, editorWidth, role, speed);
  };
  
  //播放pattern
  // playPattern(uid, pf, videoId, videoEl, domId, editorWidth, role, speed){
  //   if(!(patternSocket && patternSocket.socketInstanceList.length > 0)){
  //     let oldReactDom = document.getElementById(domId);
  //     ReactDOM.unmountComponentAtNode(oldReactDom);
  //     this.lvsPatternEditorId = "lvs_pattern_editor" + (new Date().getTime());
  //   }
  //   let id = this.lvsPatternEditorId + "_event_610";
  //   let playEventSpan = document.getElementById(id);
  //   if(!playEventSpan){
  //     playEventSpan = document.createElement( "span");
  //     playEventSpan.id = id;
  //     document.body.appendChild(playEventSpan);
  //   }
  //   this.createPatternEditor(uid, pf, videoId, videoEl, domId, editorWidth, role, speed, true);
  //   setTimeout(()=>{
  //     playEventSpan.click();
  //   }, 100)
  //   //socketio同步pattern进度
  // };
  
  setSpeed(speed){
    if(this.socketService) this.socketService.setPlaySpeed(speed);
  };
  //关闭编辑器
  close(){
    const pEditor = document.getElementById(this.lvsPatternEditorId);
    const editorParent = document.getElementById(this.domId);
    editorParent.removeChild(pEditor);
  };
  //参数校验
  checkParams(videoEl, domId, editorWidth){
    if(!domId){
      console.error("Missing parameter domId !");
      return false;
    }
    if(!editorWidth){
      console.error("Missing parameter editorWidth !");
      return false;
    }
    if(!videoEl){
      console.error("Missing parameter videoEl !");
      return false;
    }
    return true;
  };
}

export default PatternEditor